import(/* webpackMode: "eager" */ "/codebuild/output/src1347810820/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/docs/docs.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["DocsSidebar"] */ "/codebuild/output/src1347810820/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/docs/DocsSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src1347810820/src/github.com/Singularity-DAO/sfi-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1347810820/src/github.com/Singularity-DAO/sfi-frontend/node_modules/next/dist/client/image-component.js");
